<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Search</label>
          <div class="col-sm-4">
            <div>
              <el-input
                placeholder=""
                v-model="searchName"
                name="search"
              ></el-input>
            </div>
          </div>
          <label class="col-sm-2 control-label">{{
            $t("message.Status")
          }}</label>
          <div class="col-sm-4">
            <div>
              <el-select
                v-model="status"
                clearable
                v-bind:placeholder="$t('message.PleaseSelect')"
              >
                <el-option
                  v-for="item in statusObj"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">
                {{ $t("message.Search") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                style="width: 100%"
                border
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                @sort-change="sortChange"
                @row-dblclick="handleDbClick"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="titleen_US"
                  :show-overflow-tooltip="true"
                  label="Promotion Title"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  v-bind:label="$t('message.Status')"
                  width="170"
                ></el-table-column>
                <el-table-column
                  prop="startDate"
                  label="Start Date"
                ></el-table-column>
                <el-table-column
                  prop="endDate"
                  label="End Date"
                ></el-table-column>
                <el-table-column
                  prop="updatedTime"
                  label="Last Update Date"
                ></el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                   :current-page="page+1"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
            <div class="col-sm-12 row" style="margin-top: -30px">
              <div class="pull-right">
                <button
                  class="btn btn-white"
                  @click="orderEvent"
                   v-if="checkPermission('HIGHLIGHTS_LIST_UPDATE')"
                >{{$t("message.Rearrange Order") }}</button>
                <button
                  class="btn btn-white"
                  @click="gotoDetail"
                  v-if="checkPermission('EDITORIAL_LIST_NEW')"
                >
                  {{ $t("message.Add") }}
                </button>
                <button
                  class="btn btn-white"
                  @click="showWarning"
                  v-if="checkPermission('EDITORIAL_LIST_DELETE')"
                >
                  {{ $t("message.Delete") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0,
      pagesize: 10,
      searchName: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "asc",
      sortField: "sortOrder",
      eventTypes: "",
      status: "",
      statusObj: [],
    };
  },
  created: function () {
    
    if(this.$route.query.sortField){
      this.sortField = this.$route.query.sortField;
    }
    if(this.$route.query.page){
      this.page = parseInt(this.$route.query.page);
    }
    if(this.$route.query.pagesize){
      this.pagesize = parseInt(this.$route.query.pagesize);
    }
    if(this.$route.query.searchName){
      this.searchName = this.$route.query.searchName;
    }
    if(this.$route.query.status){
      this.status = this.$route.query.status;
    }
  },
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.title = this.searchName;
      objdata.status = this.status;
      objdata.apiUrl = "/getPromotionList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      let list = null;
      for (var i = 0; i < data.data.resultList.length; i++) {
        for (var j = 0; j < data.data.resultList[i].langMap.length; j++) {
          if (data.data.resultList[i].langMap[j].langCode == "en_US") {
            data.data.resultList[i]["title" + "en_US"] =
              data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_HK") {
            data.data.resultList[i]["title" + "zh_HK"] =
              data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_CN") {
            data.data.resultList[i]["title" + "zh_CN"] =
              data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.rows = data.data.resultList;
      this.setObj();
      this.total = data.data.totalRows;
    },
    gotoDetail() {
      this.$router.push({ 
        path: "/main/promotionDetail", 
        query: {
          sortField:this.sortField,
          page:this.page,
          pagesize:this.pagesize,
          searchName:this.searchName,
          status:this.status,
        } 
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 0;
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = "/deletePromotion";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/promotionDetail",
        query: {
          id: row.id,
          sortField:this.sortField,
          page:this.page,
          pagesize:this.pagesize,
          searchName:this.searchName,
          status:this.status,
        },
      });
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "0",
          label: "Draft",
        },
        {
          value: "1",
          label: "Unpublish",
        },
        {
          value: "2",
          label: "Expired",
        },
        {
          value: "10",
          label: "Publish",
        },
      ];
      let list = null;
      for (list of this.rows) {
        list.popular += "";
        if (list.status === 0) {
          list.status = "Draft";
        } else if (list.status == 1) {
          list.status = "Unpublish";
        } else if (list.status == 2) {
          list.status = "Expired";
        } else if (list.status == 10) {
          list.status = "Publish";
        }
      }
    },
    orderEvent:function(){
      var that = this;
      this.$store.commit("setorderpromotionlist", {
        callback:function(item){
          that.$store.commit("setorderpromotionlist", { string: "", boolean: false });
          that.updateHighlights(item)
        },
        boolean: true,
        button: []
      });
    },
    async updateHighlights(item) {
      let ids = [];
      let objdata = this.getAuthObj();
      if (item.length != 0) {
        for (let i = 0; i < item.length; i++) {
          ids.push(item[i].id);
        }
      }
      objdata.promotionIds = ids;

      objdata.apiUrl = '/updatePromotionOrder'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      if (data.data.errorCode === 0) {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>